import { ReactNode } from "react"

export function AppSectionHeaderBox({ children }: {
  children?: ReactNode;
})
{
  return (
<div className="d-flex justify-content-between mt-4 mb-3">
  { children }
</div>
  )
}
